import { IHttpParamSerializer, IHttpService, IPromise } from 'angular';
import { GmcApi } from '../../constants/gmc-api';
import {
  ITableCandidateData,
  ITableCandidatesRes,
  TableCandidate
} from './table-candidate';
import { ApiService } from '../api-service/api.service';

export class CandidateService {
  static $inject = ['ApiService', '$http', 'GmcApi', '$httpParamSerializer'];

  constructor(
    private apiService: ApiService,
    private $http: IHttpService,
    private gmcApi: GmcApi,
    private $httpParamSerializer: IHttpParamSerializer
  ) {}

  getFavorites(params: object = {}): IPromise<ITableCandidateData> {
    return this.apiService
      .post<any>('/user/getMyFavorites', this.$httpParamSerializer(params), {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      })
      .then((res) => {
        return {
          count: res.count || 0,
          pages: res.pages || 0,
          candidates: res.data.map((item) => new TableCandidate(item))
        };
      });
  }

  getCrew(params: object): IPromise<ITableCandidateData> {
    return this.apiService
      .post<ITableCandidatesRes>(
        '/user/getMyCrew',
        this.$httpParamSerializer(params),
        {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }
      )
      .then((res) => {
        return {
          count: res.count || 0,
          pages: res.pages || 0,
          candidates: res.data.map((item) => new TableCandidate(item))
        };
      });
  }

  getTopCandidates(params: object = {}): IPromise<ITableCandidateData> {
    return this.apiService
      .post<ITableCandidatesRes>(
        '/user/getAllCandidates',
        this.$httpParamSerializer(params),
        {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }
      )
      .then((res) => {
        return {
          count: res.count || 0,
          pages: res.pages || 0,
          first_100: res.first_100 || [],
          candidates: res.data.map((item) => new TableCandidate(item))
        };
      });
  }

  getTopCandidatesPublic(): IPromise<ITableCandidateData> {
    return this.$http
      .get<ITableCandidatesRes>(this.gmcApi.user.getAllCandidatesLight)
      .then((res) => {
        return {
          count: res.data.count,
          pages: res.data.pages,
          candidates: res.data.data.map((item) => new TableCandidate(item))
        };
      });
  }

  addToFavorite(candidateId: string): IPromise<any> {
    return this.$http
      .post<any>(this.gmcApi.candidates.addToFavorites, { id: candidateId })
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        throw new Error(err.data ? err.data.text : 'Error');
      });
  }

  removeFromFavorite(candidateId: string): IPromise<any> {
    return this.$http
      .post<any>(this.gmcApi.candidates.removeFromFavorite, { id: candidateId })
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        throw new Error(err.data ? err.data.error : 'Error');
      });
  }

  addToCrew(candidateId: string): IPromise<any> {
    return this.$http
      .post<any>(this.gmcApi.candidates.addToMyCrew, { id: candidateId })
      .then((res) => res.data)
      .catch((err) => {
        throw new Error(err.data ? err.data.error : 'Error');
      });
  }

  removeFromCrew(candidateId: string): IPromise<any> {
    return this.$http
      .post<any>(this.gmcApi.candidates.removeFromMyCrew, { id: candidateId })
      .then((res) => res.data)
      .catch((err) => {
        throw new Error(err.data ? err.data.error : 'Error');
      });
  }

  getNote(candidateId: string): IPromise<string> {
    return this.$http
      .get<any>(`${this.gmcApi.candidates.getNote}/?id=${candidateId}`)
      .then((res) => res.data.text)
      .catch((err) => {
        throw new Error(err.data ? err.data.text : 'Error');
      });
  }

  updateNote(candidateId: string, note: string = ''): IPromise<any> {
    return this.$http
      .post<any>(this.gmcApi.candidates.updateNote, {
        id: candidateId,
        text: note
      })
      .then((res) => res.data)
      .catch((err) => {
        throw new Error(err.data ? err.data.text : 'Error');
      });
  }

  getCvById(candidateId): IPromise<any> {
    return this.$http
      .get<any>(`${this.gmcApi.cv.one}?id=${candidateId}&type=full`)
      .then((res) => {
        return res.data.data;
      })
      .catch((err) => {
        throw new Error(err.data ? err.data.text : 'Error');
      });
  }
}



// WEBPACK FOOTER //
// ./app/core/services/candidate/candidate.service.ts